import type { WindowUnit, WindowInfill } from "building-types/windows/windowTypes";
import type { Table } from "common/data/table";

export function windowInfillsOnLevel(
  levelId: string,
  units: Table<WindowUnit>,
  infills: Table<WindowInfill>,
): [WindowUnit, WindowInfill][] {
  const a: [WindowUnit, WindowInfill][] = [];
  for (const id in infills) {
    const unit = units[id];
    const infill = infills[id];
    if (unit && unit.windowPlacement.frontRoom?.level.id === levelId) {
      a.push([unit, infill]);
    }
  }
  return a;
}
